import React from 'react';
import { Grid, TextField } from '@material-ui/core';
import { SettingsFieldsProps } from './types';

const EmailCredentialsFields: React.FC<SettingsFieldsProps> = ({
  s,
  se,
  handleChange,
}) => (
  <>
    <Grid item xs={12}>
      <TextField
        fullWidth
        name="settings.email"
        value={s.email ?? ''}
        onChange={handleChange}
        error={!!se.email}
        helperText={se.email}
        label="Email"
        variant="outlined"
      />
    </Grid>
    <Grid item xs={12}>
      <TextField
        fullWidth
        type="password"
        name="settings.password"
        value={s.password ?? ''}
        onChange={handleChange}
        error={!!se.password}
        helperText={se.password}
        label="Password"
        variant="outlined"
      />
    </Grid>
  </>
);

export default EmailCredentialsFields;
